import { ArrowLeft, Check, Eye, EyeOff } from "lucide-react";
import { FormEvent, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { Logo } from "../components/Logo";
import { ApiError } from "../lib/api";

export function RegisterPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { register } = useAuth();
  const requestedNext = params.get("next");
  const safeNext = requestedNext?.startsWith("/") && !requestedNext.startsWith("//") ? requestedNext : null;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(name, email, password);
      navigate(safeNext ?? "/activate", { replace: true });
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : "No pudimos crear tu cuenta");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-top"><Link to="/" className="icon-link"><ArrowLeft size={20} /></Link><Logo compact /></div>
      <div className="auth-card">
        <div className="auth-heading"><span className="step-label">Paso 1 de 2</span><h1>Creá tu cuenta</h1><p>Después vincularemos el código único incluido con tus XR4.</p></div>
        <form onSubmit={submit} className="form-stack">
          <label>Nombre<input value={name} onChange={(event) => setName(event.target.value)} autoComplete="name" placeholder="Tu nombre" minLength={2} required /></label>
          <label>Email<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" placeholder="tu@email.com" required /></label>
          <label>Contraseña<div className="password-field"><input type={visible ? "text" : "password"} value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="new-password" placeholder="Mínimo 10 caracteres" minLength={10} required /><button type="button" onClick={() => setVisible((value) => !value)} aria-label="Mostrar contraseña">{visible ? <EyeOff size={19} /> : <Eye size={19} />}</button></div></label>
          <div className={password.length >= 10 ? "password-hint valid" : "password-hint"}><Check size={15} /> Al menos 10 caracteres</div>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="button primary large" disabled={busy}>{busy ? "Creando…" : "Continuar"}</button>
        </form>
        <p className="auth-footer">¿Ya tenés una cuenta? <Link to={safeNext ? `/login?next=${encodeURIComponent(safeNext)}` : "/login"}>Ingresar</Link></p>
      </div>
    </div>
  );
}
